import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { icon: "mdi-cog" }),
          _cache[21] || (_cache[21] = _createTextVNode("   Settings ")),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "profile" }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode("Profile")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "security" }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode("Security")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs_window_item, { value: "profile" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, { fluid: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode("👩‍⚕️ Specialist Information")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, {
                        row: "",
                        wrap: "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                class: "white--text align-end",
                                height: 200,
                                width: 200,
                                style: {"border-radius":"100%","border":"1px solid black"},
                                src: _ctx.specialist.avatarUrl
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                label: "📇️ Specialist Name",
                                dense: "",
                                outlined: "",
                                required: "",
                                placeholder: "John Smith",
                                disabled: "",
                                modelValue: _ctx.specialist.name,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.specialist.name) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_text_field, {
                                label: "👩‍⚕️️ Specialist Title",
                                dense: "",
                                outlined: "",
                                required: "",
                                placeholder: "Head Of Medicine",
                                disabled: "",
                                modelValue: _ctx.specialist.title,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.specialist.title) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_textarea, {
                                label: "🧘‍♀️ Specialist Description",
                                dense: "",
                                "auto-grow": "",
                                outlined: "",
                                required: "",
                                placeholder: "Experienced doctor",
                                disabled: "",
                                modelValue: _ctx.specialist.description,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.specialist.description) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, {
                        row: "",
                        wrap: "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            label: "📸 Specialist Avatar",
                            dense: "",
                            outlined: "",
                            required: "",
                            disabled: "",
                            modelValue: _ctx.specialist.avatarUrl,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.specialist.avatarUrl) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createTextVNode("⏳ Session Info")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, {
                        row: "",
                        wrap: "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                label: "📜 Experience Info",
                                dense: "",
                                placeholder: "Best of the best",
                                outlined: "",
                                required: "",
                                disabled: "",
                                modelValue: _ctx.specialist.experience,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.specialist.experience) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_text_field, {
                                label: "⏳ Session Time",
                                dense: "",
                                outlined: "",
                                required: "",
                                placeholder: "50 min",
                                disabled: "",
                                modelValue: _ctx.specialist.sessionTime,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.specialist.sessionTime) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_combobox, {
                                modelValue: _ctx.specialist.tags,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.specialist.tags) = $event)),
                                "hide-selected": "",
                                label: "🏷️ Tags",
                                multiple: "",
                                disabled: "",
                                "persistent-hint": "",
                                "small-chips": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode("🏷️ Price & Rating")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, {
                        row: "",
                        wrap: "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "✨ Rating",
                                    dense: "",
                                    outlined: "",
                                    required: "",
                                    disabled: "",
                                    modelValue: _ctx.specialist.rating,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.specialist.rating) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "📈 Reviews",
                                    dense: "",
                                    outlined: "",
                                    required: "",
                                    disabled: "",
                                    modelValue: _ctx.specialist.reviews,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.specialist.reviews) = $event))
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "1" }),
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                label: "💸 Consultation Price Tag",
                                dense: "",
                                outlined: "",
                                required: "",
                                disabled: "",
                                modelValue: _ctx.specialist.priceTag,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.specialist.priceTag) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode("🏷️ Price & Fee for Sequoia Cabinet")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, {
                        row: "",
                        wrap: "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                label: "💸 Consultation Price",
                                dense: "",
                                outlined: "",
                                required: "",
                                placeholder: "9.99",
                                disabled: "",
                                modelValue: _ctx.specialist.price.amount,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.specialist.price.amount) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "1" }),
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                label: "🗺️ Price Currency",
                                items: ['USD', 'EUR', 'BYN', 'RUB', 'GBP', 'SAR', 'AED', 'CNY'],
                                variant: "outlined",
                                required: "",
                                outlined: "",
                                disabled: "",
                                dense: "",
                                placeholder: "USD",
                                modelValue: _ctx.specialist.price.currency,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.specialist.price.currency) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                label: "% Sequoia Fee",
                                dense: "",
                                outlined: "",
                                required: "",
                                placeholder: "0.15",
                                disabled: "",
                                modelValue: _ctx.specialist.price.fee,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.specialist.price.fee) = $event))
                              }, null, 8, ["modelValue"]),
                              _createTextVNode(" = " + _toDisplayString((_ctx.specialist.price.fee * 100).toFixed(2)) + " % ", 1),
                              _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("b", null, "🏷️ Specialist will receive: " + _toDisplayString((_ctx.specialist.price.amount * (1 - _ctx.specialist.price.fee)).toFixed(2)) + " " + _toDisplayString(_ctx.specialist.price.currency), 1),
                              _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("b", null, "🌳 Sequoia will receive: " + _toDisplayString((_ctx.specialist.price.amount * _ctx.specialist.price.fee).toFixed(2)) + " " + _toDisplayString(_ctx.specialist.price.currency), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createTextVNode("📦 Configuration")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, {
                        row: "",
                        wrap: "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                label: "📦 Enabled",
                                modelValue: _ctx.specialist.enabled,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.specialist.enabled) = $event)),
                                dense: "",
                                outlined: "",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "2" }),
                          _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                "item-title": "localeTitle",
                                "item-value": "locale",
                                items: _ctx.localeItems,
                                label: "🌎 Specialist Speaks",
                                modelValue: _ctx.specialist.localesToSpeak,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.specialist.localesToSpeak) = $event)),
                                disabled: "",
                                dense: "",
                                multiple: "",
                                outlined: ""
                              }, null, 8, ["items", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createTextVNode("🗃️ Career Highlights")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, { class: "pa-2 justify-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_data_table, {
                            headers: [
                                    { title: '📸 Logo', value: 'logoUrl', sortable: false, width: 70 },
                                    { title: '👩‍⚕️ Title', value: 'title', width: 300 },
                                    { title: '🧘‍♀️ Subtitle', value: 'subtitle', },
                                    { title: '🏢 Place', value: 'place', width: 300 },
                                    // { title: '🔗 URL', value: 'logoUrl', width: 500 },
                                    // { title: '🏆 Certificate', value: 'certificateUrl', width: 500 },
                                ],
                            items: _ctx.specialist.career,
                            "item-key": "name",
                            class: "elevation-1"
                          }, {
                            top: _withCtx(() => [
                              _createVNode(_component_v_toolbar, { flat: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_toolbar_title, null, {
                                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                                      _createTextVNode("🗃️ Career Highlights")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 1
                              })
                            ]),
                            item: _withCtx(({ item }) => [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", {
                                    class: "circular",
                                    style: _normalizeStyle({
                                            'width': '40px',
                                            'height': '40px',
                                            'background-repeat':
                                            'round',
                                            'border-radius': '100%',
                                            'border': '1px solid black',
                                            'background-image': 'url(' + item.logoUrl + ')' })
                                  }, null, 4)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "Title",
                                    required: "",
                                    placeholder: "Company",
                                    disabled: "",
                                    modelValue: item.title,
                                    "onUpdate:modelValue": ($event: any) => ((item.title) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "Subtitle",
                                    required: "",
                                    placeholder: "2020 - 2030",
                                    disabled: "",
                                    modelValue: item.subtitle,
                                    "onUpdate:modelValue": ($event: any) => ((item.subtitle) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "Place",
                                    required: "",
                                    placeholder: "2020 - 2030 · Company",
                                    disabled: "",
                                    modelValue: item.place,
                                    "onUpdate:modelValue": ($event: any) => ((item.place) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createTextVNode("🎓 Education Highlights")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_layout, { class: "pa-2 justify-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_data_table, {
                            headers: [
                                    { title: '📸 Logo', value: 'logoUrl', sortable: false, width: 70 },
                                    { title: '👩‍⚕️ Title', value: 'title', width: 300 },
                                    { title: '🧘‍♀️ Subtitle', value: 'subtitle', },
                                    { title: '🏢 Place', value: 'place', width: 300 },
                                    // { title: '🔗 URL', value: 'logoUrl', width: 500 },
                                    // { title: '🏆 Certificate', value: 'certificateUrl', width: 500 },
                                ],
                            items: _ctx.specialist.education,
                            "item-key": "name",
                            class: "elevation-1"
                          }, {
                            top: _withCtx(() => [
                              _createVNode(_component_v_toolbar, { flat: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_toolbar_title, null, {
                                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                                      _createTextVNode("🎓 Education Highlights")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 1
                              })
                            ]),
                            item: _withCtx(({ item }) => [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", {
                                    class: "circular",
                                    style: _normalizeStyle({
                                            'width': '40px',
                                            'height': '40px',
                                            'background-repeat':
                                            'round',
                                            'border-radius': '100%',
                                            'border': '1px solid black',
                                            'background-image': 'url(' + item.logoUrl + ')' })
                                  }, null, 4)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "Title",
                                    required: "",
                                    placeholder: "Company",
                                    disabled: "",
                                    modelValue: item.title,
                                    "onUpdate:modelValue": ($event: any) => ((item.title) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "Subtitle",
                                    required: "",
                                    placeholder: "2020 - 2030",
                                    disabled: "",
                                    modelValue: item.subtitle,
                                    "onUpdate:modelValue": ($event: any) => ((item.subtitle) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_text_field, {
                                    label: "Place",
                                    required: "",
                                    placeholder: "2020 - 2030 · Company",
                                    disabled: "",
                                    modelValue: item.place,
                                    "onUpdate:modelValue": ($event: any) => ((item.place) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_tabs_window_item, { value: "security" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.passwordFormValid,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.passwordFormValid) = $event)),
                    onSubmit: _withModifiers(_ctx.onChangePassword, ["prevent"]),
                    "lazy-validation": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.newPassword,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newPassword) = $event)),
                        readonly: _ctx.loading,
                        rules: _ctx.rules.newPassword,
                        "append-icon": _ctx.show ? 'mdi-eye' : 'mdi-eye-off',
                        type: _ctx.show ? 'text' : 'password',
                        label: "Password",
                        placeholder: "Enter your password",
                        clearable: "",
                        "onClick:append": _cache[17] || (_cache[17] = ($event: any) => (_ctx.show = !_ctx.show))
                      }, null, 8, ["modelValue", "readonly", "rules", "append-icon", "type"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.newRepeatedPassword,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newRepeatedPassword) = $event)),
                        readonly: _ctx.loading,
                        rules: _ctx.rules.newRepeatedPassword,
                        type: _ctx.show ? 'text' : 'password',
                        label: "Password",
                        placeholder: "Enter your password",
                        clearable: ""
                      }, null, 8, ["modelValue", "readonly", "rules", "type"]),
                      _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_v_btn, {
                        disabled: !_ctx.passwordFormValid,
                        loading: _ctx.loading,
                        color: "success",
                        size: "large",
                        type: "submit",
                        variant: "elevated",
                        block: ""
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createTextVNode(" Update password ")
                        ])),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onSubmit"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}